// ======================================================================
// File Name       : superUser
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const SUPERUSER_EDIT = 'SUPERUSER_EDIT';
export const SUPERUSER_RECEIVE_SEARCH_RESULT = 'SUPERUSER_RECEIVE_SEARCH_RESULT';
export const SUPERUSER_RECEIVE_ENRTERPRISES = 'SUPERUSER_RECEIVE_ENRTERPRISES';
export const SUPERUSER_RECEIVE_ALL_SERVICE = 'SUPERUSER_RECEIVE_ALL_SERVICE';
export const SUPERUSER_RESET_INIT_DATA = 'SUPERUSER_RESET_INIT_DATA';
export const SUPERUSER_RECEIVE_SETTING_LIST = 'SUPERUSER_RECEIVE_SETTING_LIST';
